class ImageLightbox extends HTMLElement {
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    this.innerHTML = `
      <div class="image-lightbox__backdrop"></div>
      <div class="image-lightbox__inner">
        <button class="image-lightbox__close" aria-label="Close image preview">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" aria-hidden="true" focusable="false">
            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z"/>
          </svg>
        </button>
        <div class="loading-overlay__spinner">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
        <img class="image-lightbox__img hidden" src="" alt="Engraving preview" />
      </div>
    `;

    this._backdrop = this.querySelector('.image-lightbox__backdrop');
    this._spinner  = this.querySelector('.loading-overlay__spinner');
    this._img      = this.querySelector('.image-lightbox__img');

    this.querySelector('.image-lightbox__close').addEventListener('click', () => this.close());
    this.addEventListener('click', (e) => {
      if (!e.target.closest('.image-lightbox__inner')) this.close();
    });

    this._keyHandler = (e) => { if (e.key === 'Escape') this.close(); };

    // Delegated click — any [data-lightbox] link on the page
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-lightbox]');
      if (!trigger) return;
      e.preventDefault();
      this.open(trigger.href || trigger.dataset.lightbox);
    });
  }

  open(url) {
    this._spinner.classList.remove('hidden');
    this._img.classList.add('hidden');
    this._img.src = '';

    this.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this._keyHandler);

    this._img.onload = () => {
      this._spinner.classList.add('hidden');
      this._img.classList.remove('hidden');
    };

    this._img.onerror = () => {
      this._spinner.classList.add('hidden');
    };

    // Set src after handlers are attached
    this._img.src = url;
  }

  close() {
    this.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this._keyHandler);
    this._img.src = '';
  }
}

customElements.define('image-lightbox', ImageLightbox);
